import { createContext, useContext, type RefObject } from "react";

export interface WindowState {
    id: string;
    title: string;
    z: number;
    minimized: boolean;
    x: number;
    y: number;
}

export interface WindowApi {
    windows: WindowState[];
    focusedId: string | null;
    loading: string | null;
    constraintsRef: RefObject<HTMLDivElement | null>;
    open: (id: string) => void;
    close: (id: string) => void;
    focus: (id: string) => void;
    minimize: (id: string) => void;
    skipLoading: () => void;
}

export const WindowContext = createContext<WindowApi | null>(null);

export function useWindows(): WindowApi {
    const ctx = useContext(WindowContext);
    if (!ctx) throw new Error("useWindows must be used inside WindowProvider");
    return ctx;
}
